<template>
  <section class="kds-debate-timeline">
    <ul v-if="rows.length > 0" class="kds-debate-timeline__list">
      <KdsDebateTimelineRow
        v-for="row in rows"
        :key="row.id"
        v-bind="row"
      />
    </ul>
    <div v-else class="kds-debate-timeline__empty">
      <KdsEyebrow>Empty timeline</KdsEyebrow>
      <p class="kds-debate-timeline__empty-body">{{ emptyLabel }}</p>
    </div>
  </section>
</template>

<script setup lang="ts">
import KdsDebateTimelineRow from './KdsDebateTimelineRow.vue';
import KdsEyebrow from '@/kds/primitives/KdsEyebrow.vue';
import type { PersonaSegment } from '@/kds/types';

interface Row {
  id: string;
  timestamp: string;
  segment: PersonaSegment;
  personaName: string;
  personaId: string;
  text: string;
  turn: number;
  totalTurns: number;
  live?: boolean;
}

interface Props {
  rows: Row[];
  emptyLabel?: string;
}

withDefaults(defineProps<Props>(), {
  emptyLabel: 'No debate running. Pick a panel and choose a protocol to start.'
});
</script>

<style scoped lang="scss">
.kds-debate-timeline {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);

  &__list {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  &__empty {
    display: flex;
    flex-direction: column;
    gap: var(--space-3);
    padding: var(--space-7);
    border: var(--border);
    border-style: dashed;
    border-radius: var(--r-4);
    text-align: center;
    color: var(--stone);
  }

  &__empty-body {
    margin: 0;
    color: var(--stone);
    font-size: var(--fs-body-sm);
  }
}
</style>
